type Input = {
  isOpened: boolean;
  panelElement: HTMLDivElement;
};

export const getHandleTransitionEnd = (input: Input) => {
  const handleTransitionEnd = (event?: TransitionEvent) => {
    const { isOpened, panelElement } = input;

    if (event && event.propertyName !== "height") return;

    panelElement.removeEventListener("transitionend", handleTransitionEnd);
    if (isOpened) {
      panelElement.style.height = "auto";
      panelElement.style.opacity = "1";
      panelElement.style.visibility = "";
      return;
    }

    panelElement.hidden = true;
    panelElement.style.height = "0";
    panelElement.style.opacity = "0";
    panelElement.style.visibility = "";
  };

  return handleTransitionEnd;
};
